/* eslint-disable */
import { CropPortrait } from '@material-ui/icons';
import { React, Fragment, Component } from 'react';
import Button from '@material-ui/core/Button';
// import Typography from '@material-ui/Typography';
// import Breadcrumbs from '@material-ui/Breadcrumbs';
// import Link from '@material-ui/Link';

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

// function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
//   event.preventDefault();
//   console.info('You clicked a breadcrumb.');
// }
import moment from 'moment';

import DataTable from 'react-data-table-component';
import Select from 'react-select'

import Spinner from 'components/Spinner.js';

import * as R from 'ramda';

// const columns = [
//   {
//     name: 'Site',
//     selector: row => row.locncode,
//     sortable: true,
//   },
//   {
//     name: 'Role',
//     selector: row => row.role,
//     sortable: true,
//   },
// ];

export default class PermissionList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTable: false,
      showSpinner: true,
      showSelect: false,
      permission: null,
      role: null,
      printerSites: [],
      sites: [],
      //allSites: [],
      //data: []
    };
  }

  componentDidMount() {
    this.loadPrinterSites();
    this.loadSites();
  }

  loadPrinterSites = () => {
    // this.setState({
    //   showTable: false,
    // });

    var $this = this;
    fetch('/api/shared/printers/sites/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({ printerId: $this.props.printerId })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          var printerSites = data.data.printerSiteMaps.map(p => ({
            label: p.LOCNCODE,
            value: p.LOCNCODE
          }));

          $this.setState({
            //data: data.data.roles,
            printerSites,
            showSpinner: false,
            //allSites: R.concat(printerSites, this.state.sites),
            //showTable: true
          });
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  loadSites = () => {
    var $this = this;
    fetch('/api/shared/printers/sites/list', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({})
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          var sites = data.data.sites.map(p => ({
            label: p.locncode,
            value: p.locncode
          }));;

          $this.setState({
            sites,
            //allSites: R.concat(this.state.printerSites, sites),
            // showSpinner: false,
            // showTable: true
          });
        }
        else {
          $this.setState({
            //showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          //showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  handleRoleAddRemove = (locncode, add) => {
    var tempSites = this.state.sites;
    this.setState({
      showSpinner: true,
      sites: [],
    });
    if (true || confirm(`<replace>`)) {
      var $this = this;
      fetch(`/api/shared/printers/sites/${add ? 'add' : 'remove'}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify({
          printerId: $this.props.printerId,
          locncode
      })
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          this.loadPrinterSites();
          this.loadSites();
        }
        else {
          $this.setState({
            showSpinner: false,
            sites: tempSites
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false,
          sites: tempSites
        });
        alert('There was an error. Please try again later.')
      });
    }
  }

  handlePermissionChange = (sites) => {
    if (this.state.printerSites.length > sites.length)
    {
      var permissions = R.difference(this.state.printerSites, sites);
      if (permissions.length > 0)
        this.handleRoleAddRemove(permissions[0].value, false);
    }
    else if (this.state.printerSites.length < sites.length)
    {
      var permissions = R.difference(sites, this.state.printerSites);
      if (permissions.length > 0)
        this.handleRoleAddRemove(permissions[0].value, true);
    }
    //alert(JSON.stringify(role))
  }

  render ()
  {
    const allSites = R.concat(this.state.printerSites, this.state.sites);
    console.log('printerSites' + JSON.stringify(this.state.printerSites));
    console.log('allSites' + JSON.stringify(allSites));
    return (
      <Fragment>
        { !this.state.showSpinner && this.state.sites.length > 0 ?
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={2}>
              Sites:
            </GridItem>
            <GridItem xs={12} sm={12} md={10}>
              <Select name="role" defaultValue={this.state.printerSites}
                isMulti
                onChange={this.handlePermissionChange}
                options ={allSites}
              />
            </GridItem>
          </GridContainer><br/>
        </div>
        : <Spinner/> }
      </Fragment>
    );
  }
}
